import { api } from "@/lib/api";

export const myReferrals = async () => (await api.get("/referrals/me")).data;

export const trackReferralClick = async (code, referer) =>
  (await api.post("/referrals/track-click", { code, referer })).data;

export const publicReferralInfo = async (code) =>
  (await api.get(`/referrals/public/${encodeURIComponent(code)}`)).data;

export const adminReferralLedger = async (status, page = 1, pageSize = 50) => {
  const q = new URLSearchParams();
  if (status) q.set("status", status);
  q.set("page", String(page));
  q.set("page_size", String(pageSize));
  return (await api.get(`/referrals/admin/ledger?${q.toString()}`)).data;
};
